import APIDOC from '@/common/serverApi';
import { post, get } from '@/common/request';

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    // 代理加盟申请
    addMemberApply({ commit }, payload) {
      return new Promise((resolve, reject) => {
        post(APIDOC.JOINUS.addMemberApply, payload)
          .then((ret) => {
            resolve(ret);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    // 说明：获取申请情况
    getApplyInfo({ commit }, payload) {
      return new Promise((resolve, reject) => {
        get(APIDOC.JOINUS.getApplyInfo, payload)
          .then((ret) => {
            resolve(ret);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    // 说明：新申请用户点击同意合同后保存并展示
    saveApply({ commit }, payload) {
      return new Promise((resolve, reject) => {
        post(APIDOC.JOINUS.saveApply, payload)
          .then((ret) => {
            resolve(ret);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    // 说明：补充说明和附件并重新申请
    supplement({ commit }, payload) {
      return new Promise((resolve, reject) => {
        post(APIDOC.JOINUS.supplement, payload)
          .then((ret) => {
            resolve(ret);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    // 说明：加盟申请的支付或重新支付
    payApply({ commit }, payload) {
      return new Promise((resolve, reject) => {
        post(APIDOC.JOINUS.payApply, payload)
          .then((ret) => {
            resolve(ret);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    // 说明：加盟会员续费
    renewApply({ commit }, payload) {
      return new Promise((resolve, reject) => {
        post(APIDOC.JOINUS.renewApply, payload)
          .then((ret) => {
            resolve(ret);
          })
          .catch((err) => {
            reject(err);
          });
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/joinus.js